module.exports = __webpack_public_path__ + "img/button diameter.d639c016.png";